// import Vue from 'vue';
import {createRouter, createWebHashHistory} from 'vue-router';
// import {createRouter, createWebHistory} from 'vue-router';
// Vue.use(VueRouter);

import Home from '@/components/home.vue';
import Apply from '@/components/apply.vue';
import Progress from '@/components/progress.vue';
// 配置路由
const routes = [
    {
        path:"/",
        // path:"/xwlf",
        name:"Home",
        component: Home
    },
    {
        path:"/xwlf/apply/:departcode",
        // path:"/apply/:departcode",
        name:"Apply",
        component: Apply
    },
    {
        path:"/xwlf/progress/:zjh",
        // path:"/progress/:zjh",
        name:"Progress",
        component: Progress
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    // history: createWebHistory(),
    routes
})
export default router;